import { render, staticRenderFns } from "./DxPestsDiseasesDatabase.vue?vue&type=template&id=02292cea&"
import script from "./DxPestsDiseasesDatabase.vue?vue&type=script&lang=js&"
export * from "./DxPestsDiseasesDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports